import { useNavigate } from 'react-router-dom';
import Axios from 'axios';
import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useEffect, useState } from 'react';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  TextField,
} from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import Label from '../components/label';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';

import config from '../config.json'

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  // { id: 'nome', label: 'Nome', alignRight: false, sticky: true, left:35},
  { id: 'status', label: 'Status', alignRight: false },
  { id: 'id', label: 'ID', alignRight: false},
  { id: 'nome', label: 'Nome', alignRight: false},
  { id: 'razaosocial', label: 'Razão Social', alignRight: false },
  { id: 'evento', label: 'Evento', alignRight: false, },
  { id: 'documento', label: 'Documento', alignRight: false },
  { id: 'valor', label: 'Valor', alignRight: false },
  { id: 'vencimento', label: 'Vencimento', alignRight: false },
  { id: 'telefone1', label: 'Principal', alignRight: false },
  { id: 'telefone2', label: 'Celular', alignRight: false },
  // { id: 'data', label: 'Data', alignRight: false },
  { id: 'log', label: 'Log', alignRight: false },
  // { id: '' },
];


// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  
  
  if (query) {
    return filter(array, (_user) =>  
      _user.nome.toLowerCase().indexOf(query.toLowerCase()) !== -1 
      || _user.evento.toLowerCase().indexOf(query.toLowerCase()) !== -1 
      || (_user.razaosocial && _user.razaosocial.toLowerCase().indexOf(query.toLowerCase()) !== -1)
      || _user.status.toLowerCase().indexOf(query.toLowerCase()) !== -1 
      );
  }
  return stabilizedThis.map((el) => el[0]);
}

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export default function LogsPage() {
  
  const [open, setOpen] = useState(null);
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState(); // useState('vencimento'); para vir ordenado padrão
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [USERLIST, setUserList] = useState([])
  const [buttonText, setButtonText] = useState({
    atualizar: 'Atualizar',
    enviar: 'Enviar'  
  })
  const [listaSelecionados, setListaSelecionados] = useState([])
  const [logPopover, setLogPopover] = useState(null)
  const [menuFilter, setMenuFilter] = useState(null)
  const [menuFilterOptions, setMenuFilterOptions] = useState([
    {nome: 'Enviado', status: true},
    {nome: 'Pendente', status: true},
    {nome: 'Erro', status: true},
  ])
  const [dataFiltro, setDataFiltro] = useState(dayjs(new Date()));

  const navigate = useNavigate();

  useEffect(()=>{async function getEventos(filtro){
    await sleep(200)
    setListaSelecionados([]);
    setSelected([]);
    const data = dataFiltro;
    Axios.get(`${config.apiUrl}/eventos`, {params: {data,filtro}})
    .then(res => {
      setUserList(res.data)
      setButtonText({atualizar: 'Atualizar', enviar: 'Enviar'})
    })
    }
    getEventos()},[dataFiltro])
  useEffect(validateUser)
  // useEffect(getEventos2, [dataFiltro])

  function validateUser(){
    if(!config.user._id){ 
      navigate('/', { replace: true });
    }
  }


  async function getEventos(filtro){
    await sleep(200)
    setListaSelecionados([]);
    setSelected([]);
    const data = dataFiltro;
    Axios.get(`${config.apiUrl}/eventos`, {params: {data,filtro}})
    .then(res => {
      setUserList(res.data)
      setButtonText({atualizar: 'Atualizar', enviar: 'Enviar'})
    })
    
    
  }
  

  const atualizaEventos = async () => {
    setSelected([]);
    setListaSelecionados([]);
    setButtonText({...buttonText, atualizar: 'Atualizando...'})
    await Axios.get(`${config.apiUrl}/carregaeventos`)
    .then(async res  => {await sleep(1000 + res.data*10); setDataFiltro(dayjs(new Date())); })
  }

  const reabrirLog = async ()  =>  {
    const newLogPopover = logPopover;
    newLogPopover.status = 'Pendente';
    await Axios.post(`${config.apiUrl}/eventos`, newLogPopover)
    .then(async ()  => {
      await sleep(500); 
      getEventos(); 
      handleCloseMenu();
      setSelected([]);
      setListaSelecionados([]);})
  }

  const excluirLog = async ()  =>  {
    const newLogPopover = logPopover;
    newLogPopover.status = 'Excluido';
    await Axios.post(`${config.apiUrl}/eventos`, newLogPopover)
    .then(async ()  => {
      await sleep(500); 
      getEventos(); 
      handleCloseMenu();
      setSelected([]);
      setListaSelecionados([]);})
  }

  const handleClickEnviar = async () => {
    if(listaSelecionados.length > 0){
      if(window.confirm(`Será enviado ${listaSelecionados.length} mensagens selecionadas na planilha`)){
        setButtonText({...buttonText, enviar: 'Enviando...'})
        Axios.post(`${config.apiUrl}/enviaeventos`, listaSelecionados)
        .then(() => getEventos())
        .catch(error => window.alert(error))
      }
    }else if(window.confirm(`Será enviado ${filteredUsers.length} mensagens que estão na planilha`)){
      setButtonText({...buttonText, enviar: 'Enviando...'})
      Axios.post(`${config.apiUrl}/enviaeventos`, filteredUsers)
      .then(() => getEventos())
      .catch(error => window.alert(error))
      }
  }


  const handleOpenMenu = (log) => (event) => {
    setOpen(event.currentTarget);
    setLogPopover(log)
  };

  const handleCloseMenu = () => {
    setOpen(null);
    setLogPopover(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = filteredUsers.map((n) => n.id);
      const newListaSelecionados = filteredUsers.map((n) => n);
      setSelected(newSelecteds);
      setListaSelecionados(newListaSelecionados);
      return;
    }
    setSelected([]);
    setListaSelecionados([]);
  };

  const handleClick = (event, id, row) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];
    let newSelecionados = []; 
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
      newSelecionados = newSelecionados.concat(listaSelecionados, row);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
      newSelecionados = newSelecionados.concat(listaSelecionados.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
      newSelecionados = newSelecionados.concat(listaSelecionados.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
      newSelecionados = newSelecionados.concat(listaSelecionados.slice(0, selectedIndex), listaSelecionados.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
    setListaSelecionados(newSelecionados);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - USERLIST.length) : 0;

  let filteredUsers = applySortFilter(USERLIST, getComparator(order, orderBy), filterName);
  
  const isNotFound = !filteredUsers.length && !!filterName;

  const openMenuFilter = (event) => {
    setMenuFilter(event.currentTarget)
  }

  const closeMenuFilter = () => {
    setMenuFilter(false)
  }

  const handleClickOption = (event, index) => {
    const arrayCopy = JSON.parse(JSON.stringify(menuFilterOptions)); 
    arrayCopy[index].status = !arrayCopy[index].status
    setMenuFilterOptions(arrayCopy)    
    getEventos(arrayCopy)
  };


  return (
    <>
      <Helmet>
        <title> Logs </title>
      </Helmet>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5} >
          <Typography variant="h4" gutterBottom>
            Logs
          </Typography>
          <Button variant="contained" startIcon={<Iconify icon="eva:refresh-fill" />} onClick={atualizaEventos}>
            {buttonText.atualizar}
          </Button>
          <Button variant="contained" startIcon={<Iconify icon="eva:email-fill" />} onClick={handleClickEnviar} sx={{width: 110}}>
            {buttonText.enviar}
          </Button>
        </Stack>

        <Card>
          <UserListToolbar filterName={filterName} onFilterName={handleFilterByName} onClickFilter={openMenuFilter}/>
           {selected.length > 0 ? <UserListToolbar numSelected={selected.length} /> : null}

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={USERLIST.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                    const { id, idcliente, nome, evento, telefone1, telefone2, status, log, valor, numdoc, vencimento, razaosocial } = row;
                    const selectedUser = selected.indexOf(id) !== -1;

                    return (
                        <TableRow hover key={id} tabIndex={-1} role="checkbox" selected={selectedUser}  >
                          {/* <TableCell padding="checkbox" sx={{position: "sticky", left: 0}}> */}
                          <TableCell padding="checkbox">
                            <Checkbox checked={selectedUser} onChange={(event) => handleClick(event, id, row)} />
                          </TableCell>

                          <TableCell align="left">
                            <Label color={((status === 'Pendente' || status === 'Erro' || status === 'Excluido' ) && 'error') || 'success'} onClick={handleOpenMenu(row)}>{sentenceCase(status)}</Label>
                          </TableCell>
                          <TableCell align="left">{idcliente}</TableCell>
                          <TableCell component="th" scope="row" padding="none" sx={{maxWidth: 250}}>
                              <Typography variant="subtitle2" noWrap >
                                {nome}
                              </Typography>
                          </TableCell>

                          <TableCell component="th" scope="row" padding="none" sx={{maxWidth: 250}}>
                              <Typography variant="subtitle2" noWrap color="gray" ml={1}>
                                {razaosocial}
                              </Typography>
                          </TableCell>

                          <TableCell align="left" sx={{minWidth: 100}}>{evento}</TableCell>
                          <TableCell align="left">{numdoc}</TableCell>
                          <TableCell align="left">{valor ? parseFloat(valor).toFixed(2) : ''}</TableCell>
                          <TableCell align="left">{vencimento !== null ? new Date(vencimento).toLocaleDateString() : vencimento}</TableCell>

                          <TableCell align="left">{telefone1}</TableCell>

                          <TableCell align="left">{telefone2}</TableCell>
                          
                          {/* <TableCell align="left">{new Date(data).toLocaleDateString()}</TableCell> */}

                          

                          <TableCell component="th" scope="row" padding="none">
                            <Typography variant="subtitle3" noWrap>
                                {log}
                            </Typography>
                          </TableCell>
                          
                          {/* 
                            <TableCell align="right">
                            <IconButton size="large" color="inherit" onClick={handleOpenMenu(row)}>
                              <Iconify icon={'eva:more-vertical-fill'} />
                            </IconButton>
                          </TableCell>
                          */}
                        
                        </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                {isNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper
                          sx={{
                            textAlign: 'center',
                          }}
                        >
                          <Typography variant="h6" paragraph>
                            Not found
                          </Typography>

                          <Typography variant="body2">
                            No results found for &nbsp;
                            <strong>&quot;{filterName}&quot;</strong>.
                            <br /> Try checking for typos or using complete words.
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={USERLIST.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        {(logPopover !== null && (logPopover.status === 'Enviado' || logPopover.status === 'Excluido' )) ? 
          <MenuItem onClick={reabrirLog}>
            <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
            Pendente
          </MenuItem>
          : null}
        
        {(logPopover !== null && (logPopover.status !== 'Enviado')) ? 
          <MenuItem sx={{ color: 'error.main' }} onClick={excluirLog}>
            <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
            Delete
          </MenuItem>
          : null }
      </Popover>

      {/* Pop Up Menu Filter */}
      <Popover
        open={Boolean(menuFilter)}
        anchorEl={menuFilter}
        onClose={closeMenuFilter}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 'auto+10',
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        {
          menuFilterOptions.map((option,index) => 
              <Stack direction="row" alignItems={'center'} key={index}>
                <Checkbox checked={option.status} onChange={(event) => handleClickOption(event,index)} />
                <Typography variant="subtitle1">
                  {option.nome}
                </Typography>
              </Stack>
            )
         }
         <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'pt-br'}>
          <DatePicker
            label="Data"
            value={dataFiltro}
            onChange={(newValue) => {
              setDataFiltro(newValue);
            }}
            renderInput={(params) => <TextField {...params} />}
          />
        </LocalizationProvider>
      </Popover>
    </>
  );
}
